export const HOSTS = {
  dev: 'https://api-dev.cdfsunrise.com',
  qa: 'https://api-qa.cdfsunrise.com',
  pre: 'https://api-pre.cdfsunrise.com',
  alpha: 'https://api-alpha.cdfsunrise.com',
  demo: 'https://api-demo.cdfsunrise.com',
  prod: 'https://api.cdfsunrise.com',
}

export const UBTHOSTS = {
  dev: 'https://ubttrace-dev.cdfsunrise.com',
  qa: 'https://ubttrace-qa.cdfsunrise.com',
  pre: 'https://ubttrace-pre.cdfsunrise.com',
  alpha: 'https://ubttrace-alpha.cdfsunrise.com',
  demo: 'https://ubttrace-demo.cdfsunrise.com',
  prod: 'https://ubttrace.cdfsunrise.com',
}
